export class LocalstoragePaths {
  static authPath = 'realtimedatabase.auth';
  static bearerPath = 'realtimedatabase.bearer';
}
